import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const globalFooterDefaultVariants = {}
const globalFooterCompoundVariants = []

const globalFooterSlotNames = [
  [
    "footerLayout",
    "global_footer__footerLayout"
  ],
  [
    "menuLayout",
    "global_footer__menuLayout"
  ],
  [
    "textLink",
    "global_footer__textLink"
  ],
  [
    "copyright",
    "global_footer__copyright"
  ]
]
const globalFooterSlotFns = /* @__PURE__ */ globalFooterSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, globalFooterDefaultVariants, getSlotCompoundVariant(globalFooterCompoundVariants, slotName))])

const globalFooterFn = memo((props = {}) => {
  return Object.fromEntries(globalFooterSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const globalFooterVariantKeys = []
const getVariantProps = (variants) => ({ ...globalFooterDefaultVariants, ...compact(variants) })

export const globalFooter = /* @__PURE__ */ Object.assign(globalFooterFn, {
  __recipe__: false,
  __name__: 'globalFooter',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: globalFooterVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, globalFooterVariantKeys)
  },
  getVariantProps
})